<template>
  <v-app :class="appClass">
    <v-main>
      <Notification />

      <template v-if="showHeader()">
        <TheNavigation />
      </template>

      <AppMain />

      <template v-if="showHeader()">
        <TheLayoutFooter />
      </template>
    </v-main>
  </v-app>
</template>

<style>
@media only screen and (min-width: 601px) {
  .v-application.tour-cash-register {
    margin: auto;
    max-width: 600px !important;
    border-left: 1px solid black;
    border-right: 1px solid black;
  }

  body {
    /*background-color: black;*/
  }
}
</style>

<script>
import { computed } from "vue"
import { useRoute } from "vue-router"
import AppMain from "./components/AppMain.vue"
import TheLayoutFooter from "./components/TheLayoutFooter.vue"
import TheNavigation from "./components/TheNavigation.vue"
import Notification from "./components/Notification.vue"

export default {
  name: "App",

  components: {
    TheLayoutFooter,
    TheNavigation,
    Notification,
    AppMain
  },

  setup() {
    const route = useRoute()

    const appClass = computed(() => {
      if (route.name.match(/^tour-cash-register/)) {
        document.title = "Tourkasse"
        return "tour-cash-register"
      }

      if (route.name.match(/^concert-create/)) {
        document.title = "Konzertanlage"
        return "concert-create"
      }

      if (route.name.match(/^concert-add-oracle-codes/)) {
        document.title = "Oracle-ID Vergabe"
        return "concert-add-oracle-codes"
      }

      if (route.name.match(/^requirements-overview/)) {
        document.title = "Requirements-Übersicht"
        return "requirements-overview"
      }

      if (route.name.match(/^requirements/)) {
        document.title = "Requirements"
        return "requirements"
      }

      if (route.name.match(/^venue-specs\/admin/)) {
        document.title = "Venue Specs Verwaltung"
        return "venue-specs-admin"
      }

      if (route.name.match(/^venue-specs/)) {
        document.title = "Venue Specs"
        return "venue-specs"
      }

      if (route.name.match(/^wiki/)) {
        document.title = "Wiki"
        return "wiki"
      }

      if (route.name.match(/^no-show-projects/)) {
        document.title = "Non-Show-Projects"
        return "no-show-projects"
      }

      if (route.name.match(/^avails-overview/)) {
        document.title = "Reservierungs-Übersicht"
        return "avails-overview"
      }

      if (route.name.match(/^avails-info/)) {
        document.title = "Reservierungs-Informationen"
        return "avails-info"
      }

      if (route.name.match(/^budget-overview/)) {
        document.title = "Budget-Übersicht"
        return "budget-overview"
      }

      if (route.name.match(/^budget/)) {
        document.title = "Budget"
        return "budget"
      }

      if (route.name === "watchdog-page") {
        document.title = "Watchdog"
        return "watchdog-page"
      }

      if (route.name === "budget-position-status") {
        document.title = "Budget Position Status-Verwaltung"
        return "budget-position-status"
      }

      if (route.name === "artist-concert-assignment") {
        document.title = "Künstler-Konzert-Zuordnung"
        return "artist-concert-assignment"
      }

      if (route.name === "artist-category-assignment") {
        document.title = "Künstler-Kategorie-Zuordnung"
        return "artist-category-assignment"
      }

      if (route.name === "artist-category") {
        document.title = "Kategorie-Verwaltung"
        return "artist-category"
      }

      if (route.name === "artist-accounting-artist-admin") {
        document.title = "Artist-Accounting-Rechnungsfreigabe"
        return "artist-accounting-artist-admin"
      }

      if (route.name === "artist-accounting-bookkeeping") {
        document.title = "Artist Accounting Buchhaltung"
        return "artist-accounting-bookkeeping"
      }

      if (route.name === "artist-accounting-overview") {
        document.title = "Artist Accounting Komplett-Übersicht"
        return "artist-accounting-upload-type"
      }

      if (route.name === "artist-accounting-upload-type") {
        document.title = "Upload-Typ-Verwaltung"
        return "artist-accounting-upload-type"
      }

      if (route.name === "budget-expected-invoice-type") {
        document.title = "Expected Invoice Type Management"
        return "budget-expected-invoice-type"
      }

      if (route.name === "permissions-report") {
        document.title = "Rechte-Referenz"
        return "permissions-report"
      }

      if (route.name === "incoming-invoice-batch") {
        document.title = "Batch-Erfassung"
        // Same layout class as the capture form on purpose - both belong to the
        // incoming invoice module and share its styling.
        return "incoming-invoice"
      }

      document.title = "Eingangsrechnungserfassung"
      return "incoming-invoice"
    })

    const showHeader = () => {
      return window.location === window.parent.location
    }

    return { appClass, showHeader }
  },

  data: () => ({})
}
</script>
